<template>
  <div v-if="isOpen" class="modal">
    <div
      :class="[
        'modal-content',
        termsAndPrivacy ? 'width-to-terms' : '',
        videoModal ? 'video-size' : '',
      ]"
    >
      <div :class="['header-modal', !title ? 'justify-content-end' : '']">
        {{ title }}
        <i class="fa-solid fa-xmark" @click="closeModal" />
      </div>
      <slot class="slot" />
    </div>
  </div>
</template>

<script>
let openedModals = 0;

export default {
  props: {
    isOpen: Boolean,
    title: String,
    termsAndPrivacy: Boolean,
    videoModal: Boolean,
  },
  watch: {
    isOpen(newVal) {
      this.updateScrollLock(newVal);
    },
  },
  mounted() {
    if (this.isOpen) {
      this.updateScrollLock(true);
    }
  },
  beforeUnmount() {
    if (this.isOpen) {
      this.updateScrollLock(false);
    }
  },
  methods: {
    updateScrollLock(opened) {
      openedModals = Math.max(0, openedModals + (opened ? 1 : -1));
      document.body.classList.toggle("no-scroll", openedModals > 0);
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
/* Estilização básica para o modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.header-modal {
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #283045;
  i {
    cursor: pointer;
    user-select: none;
  }
}

.video-size {
  width: 100%;
  max-width: 720px !important;
  height: auto;
}

.video-size :deep(iframe) {
  display: block;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  border: none;
}

.modal-content {
  background: #283045;
  box-shadow: 0px 3px 6px #00000029;
  min-width: 450px;
  max-width: 500px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px 20px;
}

.modal-content.video-size {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.width-to-terms {
  max-width: 750px !important;
}

@media screen and (max-width: 768px) {
  .modal-content {
    max-width: 85%;
    min-width: 0;
    padding: 10px 5px;
  }

  .width-to-terms {
    max-width: 85% !important;
  }

  .video-size {
    max-width: 85% !important;
  }
}
</style>
